import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ProfileService } from '../../services/profile.service';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-data-privacy',
  templateUrl: './data-privacy.component.html',
  styleUrl: './data-privacy.component.scss'
})
export class DataPrivacyComponent {

  person_id: number | undefined;
  exporting = false;
  confirming = false;
  deleting = false;
  error = '';

  constructor(
    protected _profile_service: ProfileService,
    protected _auth_service: AuthService,
    protected _route: ActivatedRoute
  ) {
    const person_id_param = this._route.snapshot.paramMap.get('person_id');
    this.person_id = person_id_param ? +person_id_param : undefined;
  }

  exportData() {
    this.exporting = true;
    this.error = '';
    this._profile_service.exportData(this.person_id).subscribe({
      next: (blob: Blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'owlhub-data.json';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        this.exporting = false;
      },
      error: () => {
        this.error = 'Your data could not be downloaded. Please try again.';
        this.exporting = false;
      }
    });
  }

  deleteAccount() {
    this.deleting = true;
    this.error = '';
    this._profile_service.deleteAccount().subscribe({
      next: (response) => {
        if (response.code && response.code !== 200) {
          this.fail();
          return;
        }
        this._auth_service.logout();
      },
      error: () => this.fail()
    });
  }

  private fail() {
    this.error = 'Your account could not be deleted. Please try again.';
    this.deleting = false;
  }
}
